/* eslint-disable react/no-array-index-key */
import React from 'react';
import { InputNumber, message } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import ImageLazyload from '@/components/LazyloadImage/';
import { renderIntlLabel } from '@/utils';
import { parseYuan2Currency } from '@/utils/number';

import { IGoodsNumberBtn } from '../type';
import styles from './GoodsList.module.scss';

function GoodsNumberBtn({
  storageType,
  hasAddToCart,
  item,
  intialItem,
  cartNum,
  index,
  onChangeNumber,
}: IGoodsNumberBtn) {
  if (!hasAddToCart)
    return (
      <div
        className={styles.plusBtn}
        onClick={() => {
          onChangeNumber({
            type: 'add',
            goodsItem: item,
            index,
          });
        }}
      >
        <PlusOutlined style={{ fontSize: '12px', color: '#323233', opacity: 0.65 }} />
      </div>
    );

  const inputNumberConfirm = (e: any) => {
    const val = e.target.value;
    // 正整数校验
    if (!/(^[1-9]\d*$)/.test(val)) {
      message.warn(renderIntlLabel('goods_msg_please_input_again_for_error_value'));
    } else {
      if (storageType === 2 && Number(val) > intialItem.qty) {
        message.warn(renderIntlLabel('goods_msg_please_input_again_for_error_value'));
        return;
      }
      if (storageType === 1 && Number(val) > intialItem.storageQty) {
        message.warn(renderIntlLabel('goods_msg_please_input_again_for_error_value'));
        return;
      }
      onChangeNumber({
        type: 'change',
        goodsItem: item,
        number: Number(val),
        index,
      });
    }
  };

  return (
    <div className={styles.changeNumber}>
      <span
        className={styles.btnWrapper}
        onClick={() => {
          onChangeNumber({
            type: 'reduce',
            goodsItem: item,
            index,
          });
        }}
      >
        <MinusOutlined style={{ fontSize: '12px', color: '#3F79FF' }} />
      </span>
      <InputNumber
        controls={false}
        value={cartNum}
        className={styles.number}
        min={0}
        onPressEnter={inputNumberConfirm}
        onBlur={inputNumberConfirm}
      />
      <span
        className={styles.btnWrapper}
        onClick={() => {
          onChangeNumber({
            type: 'add',
            goodsItem: item,
            index,
          });
        }}
      >
        <PlusOutlined style={{ fontSize: '12px', color: '#3F79FF' }} />
      </span>
    </div>
  );
}

// 商品列表
function GoodsList($$: any) {
  const { list = [], intialList = [], cartList, onChangeNumber, storageType } = $$;

  // 空态
  if (!list || list.length === 0) {
    return (
      <div className={styles.empty}>
        <div>
          <i />
          <p>{renderIntlLabel('goods_label_empty_goods')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.goodsList}>
      {list &&
        list.length > 0 &&
        list.map((item, index) => {
          const hasAddToCart = cartList.has(item.skuCode);
          let cartNum = 0;
          if (hasAddToCart) cartNum = cartList.get(item.skuCode).cartNum;

          const btnProps = {
            storageType,
            hasAddToCart,
            item,
            cartNum,
            onChangeNumber,
            index,
            intialItem: intialList[index],
          };
          return (
            <div className={styles.goodsItem} key={item.skuCode}>
              <div className={styles.lazyImg}>
                <ImageLazyload src={item.skuThumbnail} alt={item.spuName} />
              </div>
              <div className={styles.spuName}>{item.spuName}</div>
              <div className={styles.skuName}>{item.specValues}</div>
              <div className={styles.stock}>
                <span>
                  {renderIntlLabel('goods_label_front_stock')}：
                  <span className={hasAddToCart && storageType === 2 ? styles.sign : ''}>
                    {item.qty || 0}
                  </span>
                </span>
                <span className={hasAddToCart && storageType === 1 ? styles.sign : ''}>
                  {renderIntlLabel('goods_label_shop_stock')}：{item.storageQty || 0}
                </span>
              </div>
              <div className={styles.priceRow}>
                <span>{parseYuan2Currency(item.price || 0)}</span>
                <GoodsNumberBtn {...btnProps} />
              </div>
            </div>
          );
        })}
      {list &&
        list.length > 0 &&
        list.concat([0, 0, 0, 0]).map((item, i) => {
          return <i className={styles.emptyItem} key={i} />;
        })}
    </div>
  );
}

export default GoodsList;
